import type { ScopedThreadRef } from "@cmmd-forge/contracts";
import { useComposerDraftStore } from "../../composerDraftStore";

export interface ComposerSubmissionAcknowledgement {
  readonly messageId: string;
  readonly prompt: string;
  readonly occurredAt: string;
}

export function reconcileComposerSubmissionAcknowledgement(
  threadRef: ScopedThreadRef,
  acknowledgements: readonly ComposerSubmissionAcknowledgement[],
): void {
  const store = useComposerDraftStore.getState();
  const draft = store.getComposerDraft(threadRef);
  const staged = draft?.stagedSubmission;
  if (!draft || !staged?.messageId) return;
  if (!acknowledgements.some(({ messageId }) => messageId === staged.messageId)) return;
  if (draft.prompt === staged.prompt) store.setPrompt(threadRef, "");
  for (const attachment of staged.attachments) store.removeImage(threadRef, attachment.id);
  for (const context of staged.terminalContexts) store.removeTerminalContext(threadRef, context.id);
  store.setPendingAutoSubmit(threadRef, false);
  store.clearStagedComposerSubmission(threadRef);
}
